import { TOKENS_INFO } from '../constants'

export function findTokenFromAddr (network, addr) {
  return Object.values(TOKENS_INFO[network]).find(t => t.address.toLowerCase() === addr.toLowerCase())
}



// WEBPACK FOOTER //
// ./src/utils/token.js